<script>
import Detail from './components/detail.vue'
import CheckView from './components/view.vue'

export default {
  name: "AssaySell",
  data() {
    return {
      data: [],
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      tableKey: 0,
      loading: false,
      name: '',
    }
  },
  components: { Detail, CheckView },
  mounted() {
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$set(this, 'loading', true)
      const conditions = []
      if (this.name) {
        conditions.push({ field: 'name', operator: 'like', value1: this.name })
      }
      const params = {
        conditions: conditions,
        pageNum: this.page.current,
        pageSize: this.page.size,
        sorts: []
      }
      this.$axios.post('/paas/sys_shop_special_topic/list', params).then((res) => {
        this.$set(this, 'loading', false)
        this.$set(this, 'data', res.data.data.list)
        this.$set(this.page, 'total', res.data.data.total)
        this.tableKey += 1
      }).catch(() => {
        this.$set(this, 'loading', false)
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    fetchInit() {
      this.page.current = 1
      this.init()
    },
    handleCreate() {
      const params = {
        data: {},
        name: '专题创建',
        isUpdate: false
      }
      this.$refs.detail.display(params)
    },
    handleUpdate(row) {
      const params = {
        data: row,
        name: '专题修改',
        isUpdate: true
      }
      this.$refs.detail.display(params)
    },
    handleDelete(row) {
      const params = {
        id: row.id
      }
      this.$axios.post('/paas/eventEmit/emit/sys_shop_special_topic/sys_shop_special_topic_delete', params).then(() => {
        this.$message.success({ showClose: true, message: '删除成功！' })
        this.fetchInit()
      })
    },
    handleView(row) {
      this.$axios.get('/account/topic/manager/detail', { params: { id: row.id } }).then((res) => {
        const params = {
          data: res.data.data,
          name: '专题查看'
        }
        this.$refs.view.display(params)
      })
    },
  }
}
</script>

<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="margin-bottom: 10px;">
      <div class="fl" style="font-size: 16px; display: flex; align-items: center; height: 32px;">
        店铺专题
        <el-button type="primary" size="mini" @click="handleCreate()" style="margin-left: 10px;">创建</el-button>
        <el-input v-model="name" size="mini" placeholder="输入标题" style="margin: 0 10px; width: 200px" clearable
          @change="fetchInit"></el-input>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="85%" v-loading="loading" highlight-current-row
      :key="tableKey">
      <template #empty>
        <el-empty></el-empty>
      </template>
      <el-table-column type="index" label="序号" width="50" align="center" show-overflow-tooltip />
      <el-table-column prop="name" label='标题' minWidth="100" align="center" show-overflow-tooltip />
      <el-table-column prop="second_name" label='副标题' minWidth="100" align="center" show-overflow-tooltip />
      <el-table-column prop="type" label="专题类型" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.type === 'TenantProduct'" type="success" size="mini">煤种报价</el-tag>
          <el-tag v-else type="danger" size="mini">化验报告</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="enable" label="是否上架" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.enable" type="success" size="mini">是</el-tag>
          <el-tag v-else type="danger" size="mini">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="banner_topic" label="是否Banner" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.banner_topic" type="success" size="mini">是</el-tag>
          <el-tag v-else type="danger" size="mini">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label='创建时间' width="140" align="center" show-overflow-tooltip />
      <el-table-column prop="create_user_name" label='创建人' width="100" align="center" show-overflow-tooltip />
      <el-table-column prop="view_count" label='访问次数' width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="user_count" label='访问人数' width="100" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label='操作' width="150" align="center" fixed="right">
        <template #default="scope">
          <el-button size="mini" type="text" @click="handleView(scope.row)">查看</el-button>
          <el-button size="mini" type="text" @click="handleUpdate(scope.row)">修改</el-button>
          <el-popconfirm title="确定删除该条专题吗？" style="margin-left: 10px" @confirm="handleDelete(scope.row)"
            v-if="!scope.row.enable">
            <template #reference>
              <el-button size="mini" type="text" style="color: #F56C6C;">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: left; padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100, 200, 500, 1000]" :page-size="page.size" :total="page.total" background
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <Detail ref="detail" @init="fetchInit" />
    <CheckView ref="view" />
  </div>
</template>

<style scoped></style>
